var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7926_51707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.46875V19.5312",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 16.3271C2.34394 16.1472 2.40623 15.9729 2.5201 15.8335C2.63398 15.6942 2.79245 15.5985 2.96875 15.5625C3.67518 15.4191 4.3103 15.0358 4.76649 14.4777C5.22268 13.9195 5.47188 13.2208 5.47188 12.5C5.47188 11.7792 5.22268 11.0805 4.76649 10.5223C4.3103 9.96421 3.67518 9.58095 2.96875 9.4375C2.79245 9.40151 2.63398 9.30577 2.5201 9.16646C2.40623 9.02714 2.34394 8.85279 2.34375 8.67285V6.25C2.34375 6.0428 2.42606 5.84409 2.57257 5.69757C2.71909 5.55106 2.9178 5.46875 3.125 5.46875H21.875C22.0822 5.46875 22.2809 5.55106 22.4274 5.69757C22.5739 5.84409 22.6562 6.0428 22.6562 6.25V8.67285C22.6561 8.85279 22.5938 9.02714 22.4799 9.16646C22.366 9.30577 22.2075 9.40151 22.0313 9.4375C21.3248 9.58095 20.6897 9.96421 20.2335 10.5223C19.7773 11.0805 19.5281 11.7792 19.5281 12.5C19.5281 13.2208 19.7773 13.9195 20.2335 14.4777C20.6897 15.0358 21.3248 15.4191 22.0313 15.5625C22.2075 15.5985 22.366 15.6942 22.4799 15.8335C22.5938 15.9729 22.6561 16.1472 22.6562 16.3271V18.75C22.6562 18.9572 22.5739 19.1559 22.4274 19.3024C22.2809 19.4489 22.0822 19.5312 21.875 19.5312H3.125C2.9178 19.5312 2.71909 19.4489 2.57257 19.3024C2.42606 19.1559 2.34375 18.9572 2.34375 18.75V16.3271Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7926_51707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.65dd36e1.svg";
export { ForwardRef as ReactComponent };